import { useEffect, useState } from "react";
import { publicApi } from "../lib/api";

// Whether the answer library is launched, and whether the old FAQ page has been
// retired into it. Session-cached in the API client, so this is one request.
export default function useAskCassieStatus() {
  const [status, setStatus] = useState({ hub_live: false, faqs_retired: false, published: 0 });

  useEffect(() => {
    let live = true;
    publicApi.askCassieStatus().then((s) => live && setStatus(s)).catch(() => {});
    return () => { live = false; };
  }, []);

  return status;
}
